/**
 * 缓存
 * @param {string} key 属性
 * @param {string} val 属性值
 * @param {string} type 类型 s=>sessionStorage,l=>localStorage
 */
export function getStorage (key, type = 's') {
  if(type === 'l') return localStorage.getItem(key)
  else return sessionStorage.getItem(key)
}

export function setStorage (key, val, type = 's') {
  if(type === 'l') return localStorage.setItem(key, val)
  else return sessionStorage.setItem(key, val)
}

export function removeStorage (key, type = 's') {
  if(type === 'l') {
    if(key) return localStorage.removeItem(key)
    else localStorage.clear()
  } else {
    if(key) return sessionStorage.removeItem(key)
    else sessionStorage.clear()
  }
}


// WEBPACK FOOTER //
// ./src/utils/storage.js